<template>
  <fragment>
    <template v-if="0 === p_MyOrderList.length">
      <div class="card" style="height:300px">
        <div class="card-body d-flex justify-content-center align-items-center text-secondary">
          您还没有相关订单
        </div>
        </div>
    </template>
    <template v-if="0 !== p_MyOrderList.length">
      <div
        class="card mb-3"
        :key="`order-${order.recordType}-${order.id}-${index}`"
        v-for="(order, index) in p_MyOrderList"
      >
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          订单编号：{{ order.i_myOrderId }}
          <div class="small d-flex align-items-center">
            <template v-if="'isFinished' === order.i_orderDueStatus">
              <span class="text-danger">已完成</span>
            </template>
            <template v-if="'isOverDueEndTime' === order.i_orderDueStatus">
              <span class="text-secondary">已失效</span>
            </template>
            <template v-if="'isOverDueStartTime' === order.i_orderDueStatus">
              <template v-if="!order.isPresellTrade">
                <span class="badge bg-danger text-white mr-1"> 待支付 </span>
                <span class="text-danger" v-if="order.dueEndTimeSpan"
                  >{{ order.dueEndTimeSpan.days }}天{{
                    order.dueEndTimeSpan.hours
                  }}小时{{ order.dueEndTimeSpan.minutes }}分{{
                    order.dueEndTimeSpan.seconds
                  }}秒</span
                >
                <span class="text-white" v-if="!order.dueEndTimeSpan"
                  >0天00小时00分00秒</span
                >
              </template>
              <template
                v-if="order.isPresellTrade && 0 === order.preSellStatus"
              >
                <span class="badge bg-danger text-white mr-1"> 待付定金 </span>
                <span class="text-danger" v-if="order.dueStartTimeSpan"
                  >{{ order.dueStartTimeSpan.days }}天{{
                    order.dueStartTimeSpan.hours
                  }}小时{{ order.dueStartTimeSpan.minutes }}分{{
                    order.dueStartTimeSpan.seconds
                  }}秒</span
                >
                <span class="text-white" v-if="!order.dueStartTimeSpan"
                  >0天00小时00分00秒</span
                >
              </template>
              <template
                v-if="order.isPresellTrade && 1 === order.preSellStatus"
              >
                <span class="text-danger"
                  >{{ order.objStrDueEndTime.strDueYear }}年{{
                    order.objStrDueEndTime.strDueMonth
                  }}月{{ order.objStrDueEndTime.strDueDate }}日
                  {{ order.objStrDueEndTime.strDueHour }}:{{
                    order.objStrDueEndTime.strDueMinute
                  }}
                  支付截至</span
                >
              </template>
            </template>
            <template v-if="'isNotStarted' === order.i_orderDueStatus">
              <span class="text-danger"
                >{{ order.objStrDueStartTime.strDueYear }}年{{
                  order.objStrDueStartTime.strDueMonth
                }}月{{ order.objStrDueStartTime.strDueDate }}日
                {{ order.objStrDueStartTime.strDueHour }}:{{
                  order.objStrDueStartTime.strDueMinute
                }}
                开始支付</span
              >
            </template>
          </div>
        </div>
        <div class="card-body d-flex justify-content-between">
          <h4 v-html="order.name" />
          <!-- <span>¥{{ order.goodsPrice }}</span> -->
        </div>
        <div
          class="
            card-footer
            bg-white
            border-0
            d-flex
            justify-content-between
            align-items-center
          "
        >
          <ul class="list-inline mb-0">
            <template v-if="!order.isPresellTrade">
              <li class="list-inline-item">
                {{ 'isFinished' === order.i_orderDueStatus ? '已' : '待' }}付款
                <span class="text-danger">¥{{ order.i_realPrice }}</span>
              </li>
              <li class="list-inline-item"></li>
            </template>
            <template v-if="order.isPresellTrade">
              <li
                class="list-inline-item"
                :class="
                  0 === order.preSellStatus ? 'text-dark' : 'text-secondary'
                "
              >
                定金{{ 0 === order.preSellStatus ? '待' : '已' }}支付 ¥{{
                  order.depositPrice
                }}
              </li>
              <li
                class="list-inline-item"
                :class="
                  2 === order.preSellStatus ? 'text-secondary' : 'text-dark'
                "
                v-if="0 !== order.preSellStatus"
              >
                尾款{{ 2 === order.preSellStatus ? '已' : '待' }}支付 ¥{{
                  order.balancePrice
                }}
              </li>
            </template>
          </ul>
          <div>
            <template v-if="'isOverDueStartTime' === order.i_orderDueStatus">
              <button
                type="button"
                class="btn btn-outline-danger"
                @click.prevent="gotoOrder(order)"
                v-if="
                  !order.isPresellTrade ||
                  (order.isPresellTrade && 0 === order.preSellStatus)
                "
              >
                去支付
              </button>
              <button
                type="button"
                class="btn btn-outline-danger"
                @click.prevent="gotoOrder(order)"
                v-if="order.isPresellTrade && 1 === order.preSellStatus"
              >
                付尾款
              </button>
            </template>
            <button
              type="button"
              class="btn btn-light ml-2"
              @click.prevent="gotoOrderDetail(order)"
            >
              订单详情
            </button>
          </div>
        </div>
      </div>
    </template>
  </fragment>
</template>
<script>
import { ORDER_DETAIL_PAGE } from '@/constants/routes';
import { OrderDetailMixin } from '@/scripts/Mall/OrderDetail/OrderDetail.mixin';

export default {
  name: 'OrderList',

  mixins: [OrderDetailMixin],

  props: {
    p_MyOrderList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {};
  },

  methods: {
    gotoOrderDetail(order) {
      this.$router.push(
        `${ORDER_DETAIL_PAGE}/${order.recordType}/${order.i_myOrderId}`
      );
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
